var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatBotFullIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.69824V7.69824C20 6.59824 19.1 5.69824 18 5.69824H15C15 4.03824 13.66 2.69824 12 2.69824C10.34 2.69824 9 4.03824 9 5.69824H6C4.9 5.69824 4 6.59824 4 7.69824V9.69824C2.34 9.69824 1 11.0382 1 12.6982C1 14.3582 2.34 15.6982 4 15.6982V19.6982C4 20.7982 4.9 21.6982 6 21.6982H18C19.1 21.6982 20 20.7982 20 19.6982V15.6982C21.66 15.6982 23 14.3582 23 12.6982C23 11.0382 21.66 9.69824 20 9.69824ZM7.5 12.1982C7.5 11.3682 8.17 10.6982 9 10.6982C9.83 10.6982 10.5 11.3682 10.5 12.1982C10.5 13.0282 9.83 13.6982 9 13.6982C8.17 13.6982 7.5 13.0282 7.5 12.1982ZM16 17.6982H8V15.6982H16V17.6982ZM15 13.6982C14.17 13.6982 13.5 13.0282 13.5 12.1982C13.5 11.3682 14.17 10.6982 15 10.6982C15.83 10.6982 16.5 11.3682 16.5 12.1982C16.5 13.0282 15.83 13.6982 15 13.6982Z",
    fill: "#7D30E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBotFullIcon);
export default __webpack_public_path__ + "static/media/chat_bot_full_icon.9d1f3b11.svg";
export { ForwardRef as ReactComponent };